import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { App } from "../App";
import AuthRoute from "./authroute";

import Login from "../pages/Login";
import InvestarSearch from "../pages/InvestarSearch";
import MyAccount from "../pages/MyAccount/MyAccount";
import PropertyAnalyser from "../pages/ProppertyAnalyser/Index";
import AddPropertyStepper from "../pages/ProppertyAnalyser/PropertyStepper/Index";
import AnalysisReportIndex from "../pages/ProppertyAnalyser/AnalysisReport/Index";
import { AnalysedPropertyProvider } from "../pages/ProppertyAnalyser/PropertyStepper/Child/AnalysedPropertyContext";
import AddPropertyStepperWrapper from "../pages/ProppertyAnalyser/PropertyStepper/Child/AddPropertyStepperWrapper";
import PortfolioTrackerIndex from "../pages/PortfolioTracker";
import Archistar from "../pages/Resources/Archistar";
import ArchistarUpgrade from "../pages/Resources/ArchistarUpgrade";
import Depreciation from "../pages/Resources/Depreciation";
import InvestmentCalculators from "../pages/Resources/InvestmentCalculators";
import RPData from "../pages/Resources/RPData";
import SuburbReports from "../pages/Resources/SuburbReports/SuburbReports";
import PricingPage from "../pages/Pricing/PricingPage";
import ContactDetailsStep from "../pages/Signup/ContactDetailsStep";
import PaymentStep from "../pages/Signup/PaymentStep";
import SignupSuccess from "../pages/Signup/SignupSuccess";
import SeoPage from "../pages/SEO";

const Routing: React.FC = () => {
  return (
    <Router basename={"/"}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<App />}>
          <Route
            path=""
            element={
              <AuthRoute>
                <InvestarSearch />
              </AuthRoute>
            }
          ></Route>
          <Route
            path=":id"
            element={
              <AuthRoute>
                <InvestarSearch />
              </AuthRoute>
            }
          ></Route>
          <Route
            path="/myaccount"
            element={
              <AuthRoute>
                <MyAccount />
              </AuthRoute>
            }
          ></Route>
          <Route
            path="/property-analyser"
            element={
              <AuthRoute>
                <PropertyAnalyser />
              </AuthRoute>
            }
          ></Route>
          <Route
            path="/property-analyser/analysis-report"
            element={
              <AuthRoute>
                <AnalysisReportIndex />
              </AuthRoute>
            }
          ></Route>
          <Route
            path="/analyse-property"
            element={
              <AuthRoute>
                <AnalysedPropertyProvider>
                  <AddPropertyStepperWrapper />
                </AnalysedPropertyProvider>
              </AuthRoute>
            }
          ></Route>
          <Route
            path="/portfolio-tracker"
            element={
              <AuthRoute>
                <PortfolioTrackerIndex />
              </AuthRoute>
            }
          ></Route>
          <Route
            path="/investment-calculators"
            element={
              <AuthRoute>
                <InvestmentCalculators />
              </AuthRoute>
            }
          ></Route>
          <Route
            path="/depreciation"
            element={
              <AuthRoute>
                <Depreciation />
              </AuthRoute>
            }
          ></Route>
          <Route path="/rp-data" element={<AuthRoute><RPData /></AuthRoute>}></Route>
          <Route path="/archistar" element={<Archistar />} />
          <Route path="/archistar-upgrade" element={<ArchistarUpgrade />} />
          <Route path="/suburb-reports" element={<SuburbReports />} />
          <Route
            path="/seo"
            element={
              <AuthRoute>
                <SeoPage />
              </AuthRoute>
            }
          />
        </Route>

        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/signup/starter" element={<ContactDetailsStep />} />
        <Route path="/signup/professional" element={<ContactDetailsStep />} />
        <Route path="/signup/advanced" element={<ContactDetailsStep />} />
        <Route path="/signup/advanced-upfront" element={<ContactDetailsStep />} />
        <Route path="/starter-sign-up" element={<ContactDetailsStep />} />
        <Route path="/professional-sign-up" element={<ContactDetailsStep />} />
        <Route path="/pro-membership-sign-up-archistar" element={<ContactDetailsStep />} />
        <Route path="/signup/starter-sign-up" element={<ContactDetailsStep />} />
        <Route path="/signup/professional-sign-up" element={<ContactDetailsStep />} />
        <Route path="/signup/pro-membership-sign-up-archistar" element={<ContactDetailsStep />} />
        <Route path="/signup/payment" element={<PaymentStep />} />
        <Route path="/signup/success" element={<SignupSuccess />} />
      </Routes>
    </Router>
  );
};

export default Routing;
